import 'dotenv/config';

export default {
  // define this variable in '.env.local'
  urlSite: process.env.REACT_APP_URL_SITE ?? 'https://cclo.beecoming.fr', // urlSite: 'http://localhost:3000',
  urlRequest: process.env.REACT_APP_URL_REQUEST ?? 'https://api.cclo.beecoming.fr', // urlRequest: 'https://localhost:5001',
  urlStatistics: 'https://console.firebase.google.com/project/cclo-57932/analytics/',
  isSecure: (process.env.REACT_APP_IS_SECURE ?? 'true') !== 'false',
};
